// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 300  px !important;
  padding: 40px 40px;
}
.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  border-radius: 2px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}


.profile-img-card {
  /* width: 96px; */
  height: 105px;
  margin: 0 auto 10px;
  display: block;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  border-radius: 100px;
  /*-moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;*/
}
.dropdown-toggle::after {
  display: none !important; 
  
}
.nav-dropdown{
  color: #f50303;
  
  padding-left: 30px;
  
}
.nav-item dropdown{
  color: #f50303;
  background-color: red
}
.radio-checkbutton{
  border-radius: 10px;
  background-color: #ffffff;
  
}
.radio-checkbutton:checked{
  background-color: #64f45f;
  color: black;
}

th1 .table-space{
  width: 5%;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAGhB,kBAAkB;EAGlB,0CAA0C;AAC5C;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB;;sBAEoB;AACtB;AACA;EACE,wBAAwB;;AAE1B;AACA;EACE,cAAc;;EAEd,kBAAkB;;AAEpB;AACA;EACE,cAAc;EACd;AACF;AACA;EACE,mBAAmB;EACnB,yBAAyB;;AAE3B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,SAAS;AACX","sourcesContent":["label {\r\n  display: block;\r\n  margin-top: 10px;\r\n}\r\n\r\n.card-container.card {\r\n  max-width: 300  px !important;\r\n  padding: 40px 40px;\r\n}\r\n.card {\r\n  background-color: #f7f7f7;\r\n  padding: 20px 25px 30px;\r\n  margin: 0 auto 25px;\r\n  margin-top: 50px;\r\n  -moz-border-radius: 2px;\r\n  -webkit-border-radius: 2px;\r\n  border-radius: 2px;\r\n  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\r\n  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\r\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n\r\n.profile-img-card {\r\n  /* width: 96px; */\r\n  height: 105px;\r\n  margin: 0 auto 10px;\r\n  display: block;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\r\n  border-radius: 100px;\r\n  /*-moz-border-radius: 50%;\r\n  -webkit-border-radius: 50%;\r\n  border-radius: 50%;*/\r\n}\r\n.dropdown-toggle::after {\r\n  display: none !important; \r\n  \r\n}\r\n.nav-dropdown{\r\n  color: #f50303;\r\n  \r\n  padding-left: 30px;\r\n  \r\n}\r\n.nav-item dropdown{\r\n  color: #f50303;\r\n  background-color: red\r\n}\r\n.radio-checkbutton{\r\n  border-radius: 10px;\r\n  background-color: #ffffff;\r\n  \r\n}\r\n.radio-checkbutton:checked{\r\n  background-color: #64f45f;\r\n  color: black;\r\n}\r\n\r\nth1 .table-space{\r\n  width: 5%;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
